function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import "core-js/modules/web.dom-collections.iterator.js";
import React, { useEffect, useState } from "react";
import { Desktop, useTranslation } from "@edreamsodigeo/frontend-core";
import { Alert, Body, Box, ButtonWithLoading, Field, Flex, Glyph, Heading, InnerLabel, Input, ValidationErrorMessage } from "@edreamsodigeo/prisma-design-system";
import useCustomField from "../../clientSide/hooks/useCustomFields/useCustomField";
import { useDevice } from "../../clientSide/hooks/useDevice";
import useGenerateTripToken from "../../clientSide/hooks/useGenerateTripToken";
import { useGetActionsFromUrl } from "../../clientSide/hooks/useGetActionsFromUrl";
import useGetSuccessAuthRedirection from "../../clientSide/hooks/useGetSuccessAuthRedirection/useGetSuccessAuthRedirection";
import useTrackingBookingAuth from "../../clientSide/hooks/useTrackingBookingAuth";
import BOOKING_AUTHENTICATION_DATA from "./config/data";
const BookingAuthentication = () => {
  var _emailField$validatio, _bookingReferenceFiel, _tokenData$generateTr, _emailField$inputProp4, _bookingReferenceFiel5;
  const {
    trackEventBookingAuth
  } = useTrackingBookingAuth();
  const {
    isMobile
  } = useDevice();
  const action = useGetActionsFromUrl();
  const [error, setError] = useState("");
  const [requested, setRequested] = useState(false);
  const {
    t
  } = useTranslation();
  const {
    field: emailField,
    error: errorEmail
  } = useCustomField({
    id: BOOKING_AUTHENTICATION_DATA.email.id,
    errors: BOOKING_AUTHENTICATION_DATA.email.errors,
    trackEvent: label => trackEventBookingAuth(label, true)
  });
  const {
    field: bookingReferenceField,
    error: errorBookingReference
  } = useCustomField({
    id: BOOKING_AUTHENTICATION_DATA.bookingReference.id,
    errors: BOOKING_AUTHENTICATION_DATA.bookingReference.errors,
    trackEvent: label => trackEventBookingAuth(label, true)
  });
  const emailInvalid = !!(emailField !== null && emailField !== void 0 && (_emailField$validatio = emailField.validationProps) !== null && _emailField$validatio !== void 0 && _emailField$validatio.invalid);
  const bookingReferenceInvalid = !!(bookingReferenceField !== null && bookingReferenceField !== void 0 && (_bookingReferenceFiel = bookingReferenceField.validationProps) !== null && _bookingReferenceFiel !== void 0 && _bookingReferenceFiel.invalid);
  const {
    mutate,
    data: tokenData,
    loading: isTokenLoading,
    errors
  } = useGenerateTripToken();
  const redirectionUrl = useGetSuccessAuthRedirection(tokenData === null || tokenData === void 0 || (_tokenData$generateTr = tokenData.generateTripToken) === null || _tokenData$generateTr === void 0 ? void 0 : _tokenData$generateTr.token);
  const onFindBooking = () => {
    var _emailField$inputProp, _bookingReferenceFiel2;
    trackEventBookingAuth("find_booking_clicks");
    if (emailField !== null && emailField !== void 0 && (_emailField$inputProp = emailField.inputProps) !== null && _emailField$inputProp !== void 0 && _emailField$inputProp.value && bookingReferenceField !== null && bookingReferenceField !== void 0 && (_bookingReferenceFiel2 = bookingReferenceField.inputProps) !== null && _bookingReferenceFiel2 !== void 0 && _bookingReferenceFiel2.value && !emailInvalid && !bookingReferenceInvalid) {
      var _emailField$inputProp2, _bookingReferenceFiel3;
      setError("");
      setRequested(true);
      mutate({
        email: emailField === null || emailField === void 0 || (_emailField$inputProp2 = emailField.inputProps) === null || _emailField$inputProp2 === void 0 ? void 0 : _emailField$inputProp2.value,
        bookingId: bookingReferenceField === null || bookingReferenceField === void 0 || (_bookingReferenceFiel3 = bookingReferenceField.inputProps) === null || _bookingReferenceFiel3 === void 0 ? void 0 : _bookingReferenceFiel3.value
      });
    } else {
      var _emailField$inputProp3, _bookingReferenceFiel4;
      emailField === null || emailField === void 0 || (_emailField$inputProp3 = emailField.inputProps) === null || _emailField$inputProp3 === void 0 || _emailField$inputProp3.onBlur();
      bookingReferenceField === null || bookingReferenceField === void 0 || (_bookingReferenceFiel4 = bookingReferenceField.inputProps) === null || _bookingReferenceFiel4 === void 0 || _bookingReferenceFiel4.onBlur();
    }
  };
  useEffect(() => {
    if (requested && !isTokenLoading) {
      var _tokenData$generateTr2;
      if (tokenData !== null && tokenData !== void 0 && (_tokenData$generateTr2 = tokenData.generateTripToken) !== null && _tokenData$generateTr2 !== void 0 && _tokenData$generateTr2.token) {
        window.open(redirectionUrl, "_self");
      } else {
        trackEventBookingAuth(BOOKING_AUTHENTICATION_DATA.global.INVALID_REQUEST.track, true);
        setError(BOOKING_AUTHENTICATION_DATA.global.INVALID_REQUEST.key);
      }
      setRequested(false);
    }
  }, [isTokenLoading, tokenData, setError, setRequested, requested, errors, trackEventBookingAuth, action, redirectionUrl]);
  useEffect(() => {
    setError("");
  }, [emailField === null || emailField === void 0 || (_emailField$inputProp4 = emailField.inputProps) === null || _emailField$inputProp4 === void 0 ? void 0 : _emailField$inputProp4.value, bookingReferenceField === null || bookingReferenceField === void 0 || (_bookingReferenceFiel5 = bookingReferenceField.inputProps) === null || _bookingReferenceFiel5 === void 0 ? void 0 : _bookingReferenceFiel5.value, setError]);
  return /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(Desktop, null, /*#__PURE__*/React.createElement(Heading, {
    type: "2",
    color: "neutral.100",
    weight: "medium"
  }, t("mytripslogin.booking.authentication.title"))), /*#__PURE__*/React.createElement(Box, {
    mt: [0, "base"]
  }, /*#__PURE__*/React.createElement(Field, emailField === null || emailField === void 0 ? void 0 : emailField.fieldProps, /*#__PURE__*/React.createElement(Input, _extends({}, emailField === null || emailField === void 0 ? void 0 : emailField.inputProps, {
    invalid: !!error || emailInvalid,
    id: BOOKING_AUTHENTICATION_DATA.email.id,
    label: /*#__PURE__*/React.createElement(InnerLabel, emailField === null || emailField === void 0 ? void 0 : emailField.labelProps, /*#__PURE__*/React.createElement(Body, null, t("mytripslogin.booking.authentication.email.label")))
  }))), /*#__PURE__*/React.createElement(ValidationErrorMessage, _extends({}, emailField === null || emailField === void 0 ? void 0 : emailField.validationProps, {
    invalid: !error && emailInvalid,
    htmlFor: /*#__PURE__*/React.createElement(Glyph, {
      category: "UIActions",
      name: "ClearCircle",
      size: "small"
    })
  }), t(errorEmail))), /*#__PURE__*/React.createElement(Box, {
    mt: "base"
  }, /*#__PURE__*/React.createElement(Field, bookingReferenceField === null || bookingReferenceField === void 0 ? void 0 : bookingReferenceField.fieldProps, /*#__PURE__*/React.createElement(Input, _extends({}, bookingReferenceField === null || bookingReferenceField === void 0 ? void 0 : bookingReferenceField.inputProps, {
    invalid: !!error || bookingReferenceInvalid,
    id: BOOKING_AUTHENTICATION_DATA.bookingReference.id,
    label: /*#__PURE__*/React.createElement(InnerLabel, bookingReferenceField === null || bookingReferenceField === void 0 ? void 0 : bookingReferenceField.labelProps, t("mytripslogin.booking.authentication.reference.label"))
  }))), /*#__PURE__*/React.createElement(ValidationErrorMessage, _extends({}, bookingReferenceField === null || bookingReferenceField === void 0 ? void 0 : bookingReferenceField.validationProps, {
    invalid: !!error || bookingReferenceInvalid,
    htmlFor: /*#__PURE__*/React.createElement(Glyph, {
      category: "UIActions",
      name: "ClearCircle",
      size: "small"
    })
  }), t(error || errorBookingReference))), /*#__PURE__*/React.createElement(Alert, {
    mt: "base",
    mb: "big",
    theme: "soft",
    type: "informative"
  }, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(Flex, {
    mr: "2x_small",
    minWidth: "24px"
  }, /*#__PURE__*/React.createElement(Glyph, {
    category: "Alerts",
    name: "InfoCircle",
    size: "medium"
  })), /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column",
    gap: "1x_small"
  }, /*#__PURE__*/React.createElement(Body, {
    type: "base"
  }, t("mytripslogin.booking.authentication.info"))))), /*#__PURE__*/React.createElement(ButtonWithLoading, {
    type: isMobile ? "primary" : "secondary",
    onClick: onFindBooking,
    loading: isTokenLoading
  }, t("mytripslogin.booking.authentication.cta")));
};
export default BookingAuthentication;